import React from 'react';

/** Coloured icon header for each section panel */
export function SectionHeader({ Icon, title, subtitle }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 14,
        paddingBottom: 18,
        marginBottom: 22,
        borderBottom: '1.5px solid #f0f1f3',
      }}
    >
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: 10,
          background: '#FFF4ED',
          border: '1px solid #FFD9B8',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Icon sx={{ fontSize: 21, color: '#FF7A28' }} />
      </div>
      <div style={{ paddingTop: 3 }}>
        <div
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: '#181436',
            marginBottom: 3,
            lineHeight: 1.2,
          }}
        >
          {title}
        </div>
        {subtitle && (
          <div style={{ fontSize: 12.5, color: '#6b7280', lineHeight: 1.5 }}>{subtitle}</div>
        )}
      </div>
    </div>
  );
}
